import { render, staticRenderFns } from "./TwitchBasic.vue?vue&type=template&id=699af29c&"
import script from "./TwitchBasic.vue?vue&type=script&lang=js&"
export * from "./TwitchBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports